import { Col, Row } from "reactstrap";
import React from "react";
import InputFieldText from "Components/Common/InputFieldText";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Box, Checkbox, Typography } from "@mui/material";

const OtherDetails = ({ formik, t, isDisabled }) => {
  const {
    errors,
    touched,
    setFieldValue,
    values: { otherDetails: { declaration, isNomineeAdded } = {} },
  } = formik;

  return (
    <>
      <Row>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Nominee Name")}
            name="otherDetails.nomineeName"
            formik={formik}
            placeholder="Enter nominee name"
          />
        </Col>
        <Col md={8} sm={12}>
          <InputFieldText
            label={t("Nominee Address")}
            name="otherDetails.nomineeAddress"
            formik={formik}
            placeholder="Enter nominee address"
          />
        </Col>
        <Col md={12} sm={6}>
          <Box sx={{ display: "flex", alignItems: "start" }}>
            <Checkbox
              size="small"
              name="otherDetails.isNomineeAdded"
              checked={isNomineeAdded}
              onChange={(e) =>
                setFieldValue("otherDetails.isNomineeAdded", e.target.checked)
              }
            />
            <Box mt={1}>
              <div>
                <strong>Nomination</strong>
                <p>
                  I/ We, the Complainant/s wants to nominate the above nominee
                  as my/our representative to appear and make submissions on
                  my/our behalf before the Forum.
                </p>
              </div>
            </Box>
          </Box>
        </Col>
        <Col md={12} sm={6}>
          <Box sx={{ display: "flex", alignItems: "start" }}>
            <Checkbox
              size="small"
              name="otherDetails.declaration"
              checked={declaration}
              onChange={(e) =>
                setFieldValue("otherDetails.declaration", e.target.checked)
              }
            />
            <Box mt={1}>
              <div>
                <strong>
                  Declaration{" "}
                  {!!touched?.otherDetails?.declaration &&
                    !!errors?.otherDetails?.declaration && (
                      <>
                        <Typography color="error">
                          {errors?.otherDetails.declaration}
                        </Typography>
                      </>
                    )}
                </strong>
                <p>(a) I/ We, the Complainant/s herein declare that:</p>
                <ul>
                  <li>
                    (i) The information furnished herein above is true and
                    correct; and
                  </li>
                  <li>
                    (ii) I/ We have not concealed or misrepresented any fact
                    stated herein above and the documents submitted herewith.
                  </li>
                </ul>
                <p>
                  (b) The subject matter of the present Grievance has never been
                  submitted to the Forum by me/ or by anyone of us or by any of
                  the parties concerned with the subject matter to the best of
                  my/ our knowledge.
                </p>
                <p>
                  (c) The subject matter of my / our Grievance has not been
                  settled through the Forum in any previous proceedings.
                </p>
                <p>
                  (d) The subject matter of my / our Grievance has not been
                  decided by any competent authority/ court/arbitrator, and is
                  not pending before any such authority / court / arbitrator.
                </p>
              </div>
            </Box>
          </Box>
        </Col>
      </Row>
    </>
  );
};

OtherDetails.propTypes = {
  formik: PropTypes.object,
  isDisabled: PropTypes.bool,
  t: PropTypes.func,
};
export default withTranslation()(OtherDetails);
